import { createNotification } from '@/components';
import Link from '@/components/Link/Link';
import IntlMessages from '@/components/utility/intlMessages';
import { useAuth } from '@/contexts/auth';
import { resendConfirmationEmail } from '@/services/auth/api';
import { Button, Form, Input, Space } from 'antd';
import { useEffect, useState } from 'react';

export function ConfirmEmailForm(props) {
  const { ConfirmEmail } = useAuth();

  const [form] = Form.useForm();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  async function onSubmit(values) {
    setIsSubmitting(true);

    const payload = {
      ...values,
      email: props.email,
    };

    await ConfirmEmail(payload)
      .catch(e => {
        if (e.response) {
          createNotification('error', e.response.data.message);
        } else {
          createNotification('error', 'Network error');
        }
      })
      .finally(() => setIsSubmitting(false));
  }

  async function sendAgain() {
    setIsSubmitting(true);

    await resendConfirmationEmail(props.email)
      .then(res => {
        createNotification('success', res.message);
      })
      .catch(e => {
        if (e.response) {
          createNotification('error', e.response.data.message);
        } else {
          createNotification('error', 'Network error');
        }
      })
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Form
      layout={'vertical'}
      form={form}
      onFinish={values => {
        onSubmit(values);
      }}
    >
      <Form.Item
        name="code"
        label="Code"
        rules={[
          {
            required: true,
            message: 'Code is required',
          },
        ]}
      >
        <Input
          size="large"
          placeholder="Paste the code here"
        />
      </Form.Item>
      <Space
        align="start"
        className="flex justify-between"
      >
        <div className="flex flex-col">
          <IntlMessages id="page.confirmEmailSendAgain" />
          <Link
            className="!text-primary !hover:text-primary cursor-pointer"
            onClick={sendAgain}
          >
            <IntlMessages id="page.confirmEmailSendAgainCTA" />
          </Link>
        </div>
        <Form.Item>
          <div className="flex flex-col">
            <Button
              className="bg-primary border-0 text-white !px-8 shadow-none"
              type="primary"
              shape="round"
              size="large"
              loading={isSubmitting}
              disabled={!submittable}
              htmlType="submit"
            >
              <IntlMessages id="page.signUpButton" />
            </Button>
          </div>
        </Form.Item>
      </Space>
    </Form>
  );
}
